import { useState } from 'react'
import { changePassword } from '../api/auth'
import { useSession } from '../store/session'
import { useUI } from '../store/ui'
import { fullName, roleLabel } from '../lib/format'
import { StatusChip } from '../components/StatusChip'

export function Account() {
  const me = useSession((s) => s.me)
  const showToast = useUI((s) => s.showToast)
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit() {
    setErr('')
    if (next !== confirm) {
      setErr('The new passwords do not match.')
      return
    }
    setBusy(true)
    try {
      await changePassword(current, next)
      setCurrent('')
      setNext('')
      setConfirm('')
      showToast('Password changed — other sessions were signed out', 'success')
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Could not change password')
    } finally {
      setBusy(false)
    }
  }

  if (!me) return null
  return (
    <div className="page">
      <div className="ph">
        <div>
          <h1>My account</h1>
          <div className="desc">Your console profile and security.</div>
        </div>
      </div>

      <div className="two-col">
        <div className="card pad">
          <div className="card-title">Password</div>
          <div className="field">
            <label>Current password</label>
            <input className="input mono" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} />
          </div>
          <div className="field">
            <label>New password</label>
            <input className="input mono" type="password" value={next} onChange={(e) => setNext(e.target.value)} />
          </div>
          <div className="field">
            <label>Confirm new password</label>
            <input className="input mono" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          {err && <div className="auth-error">{err}</div>}
          <button className="btn primary mt8" disabled={busy || !current || !next} onClick={submit}>
            {busy ? 'Saving…' : 'Change password'}
          </button>
        </div>

        <div className="card pad">
          <div className="card-title">Profile</div>
          <div className="kv">
            <div className="k">Name</div>
            <div>{fullName(me.firstname, me.lastname, me.username)}</div>
            <div className="k">Email</div>
            <div className="mono">{me.email}</div>
            <div className="k">Role</div>
            <div>{roleLabel(me.roles[0] ?? '')}</div>
            <div className="k">MFA</div>
            <div>
              <StatusChip status={me.mfa_enrolled ? 'Verified' : 'Incomplete'} tone={me.mfa_enrolled ? 'success' : 'warning'} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
